import { signalStore, withState, withComputed, withMethods, patchState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { UsersService } from '../services/users/users.service';
import { firstValueFrom } from 'rxjs';
import { ContractStatus, User } from '../services/users/users.model';

type UserState = {
    user: User | undefined ;
    contract: ContractStatus | undefined ;
    loading: boolean;
}

const initialState: UserState = {
    user: undefined,
    contract: undefined,
    loading: true
};

export const UserStore = signalStore(

    { providedIn: 'root' },

    withState(initialState),

    withMethods((state) => {
        const usersService = inject(UsersService);
    
        return {
            load: async () => {
                patchState(state, {loading: true});
                const user = await usersService.getUser(false) ;
                
                if (user ) {
                    if (user.guest) {
                        patchState(state, {user, contract: undefined, loading: false});
                    } else {
                        const contract = await firstValueFrom(usersService.getContractStatus()) ;
                        patchState(state, {user, contract, loading: false});
                    }
                } else {
                    patchState(state, {user: undefined, contract: undefined, loading: false});
                }
            },
            refreshUser: async () => {
                patchState(state, {loading: true});
                const user = await usersService.getUser(true) ;
                if (user) {
                    patchState(state, {user, loading: false});
                } else {
                    patchState(state, {user: undefined, contract: undefined, loading: false});
                }
            }, 
            registerGuestUser: async (givenName: string, familyName: string) => {
                patchState(state, {loading: true});

                const guest = await firstValueFrom(usersService.registerAsGuest(givenName, familyName)) ;
                console.log("guest", guest) ;
                patchState(state, {user: guest.user, contract: undefined, loading: false});
            }
        }
    })
);